import { useRouter } from 'next/router'
import clsx from 'clsx'
import xss from 'xss'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon'
import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text'

import { useUserGroupSjt } from 'utils/hooks/useUserGroup'
import LoadingState from 'app/PemetaanKompetensiPage/components/LoadingState'
import {
  CPKvKeys,
  useGetCPKeyPairValue,
} from 'api/content-platform/useAPIKeyValue'
import ForbiddenPage from '../components/ForbiddenPage'
import PeriodGuard from '../components/PeriodGuard'
import { useSETrackEvent } from '../hooks/useSETrackEvent'
import { useMediaQueryHelper } from '../hooks/useMediaQueryHelper'
import PageBreadcrumb from '../components/PageBreadcrumb'

import type {
  IUjikomPanduanData,
  IUjikomPeriodData,
} from 'types/content-platform'

const Panduan = ({ currentDateTimeServer }) => {
  const { trackButtonClickStart } = useSETrackEvent()
  const router = useRouter()
  const { isDesktop } = useMediaQueryHelper()

  const { hasAccess: hasNecessaryRole, isLoading: isLoadingNecessaryRole } =
    useUserGroupSjt()
  const isUjikomWhitelisted = !isLoadingNecessaryRole && hasNecessaryRole
  const { isLoading, data: ujikomPanduanData } =
    useGetCPKeyPairValue<IUjikomPanduanData>(
      CPKvKeys.UjikomPanduanContent,
      isUjikomWhitelisted
    )
  const configPemKomPeriod = useGetCPKeyPairValue<IUjikomPeriodData>(
    CPKvKeys.UjikomPeriodContent,
    isUjikomWhitelisted
  )

  // To be displayed only if the role is being validated
  if (isLoadingNecessaryRole)
    return <LoadingState title="Halaman sedang dimuat..." />

  if (!isUjikomWhitelisted) return <ForbiddenPage />

  if (isLoading)
    return (
      <div className="w-full flex justify-center">
        <Spinner />
      </div>
    )

  return (
    <div className="relative flex flex-col h-screen max-w-ujikom mx-auto bg-gray-10">
      <PeriodGuard
        fullPageLoading
        currentDateTimeServer={currentDateTimeServer}
      >
        <PageBreadcrumb className="!mb-2 mt-10" />
        <div className="bg-white m-4 p-4 rounded-md">
          <Text variant="heading-md">
            {ujikomPanduanData.data.panduanTitle}
          </Text>
          <div
            className="text-left text-[15px] mt-2 ujikom-panduan-wysiwyg ol"
            dangerouslySetInnerHTML={{
              __html: xss(ujikomPanduanData.data.panduanText),
            }}
          ></div>
        </div>
        <div
          className={clsx(
            'p-4 max-w-ujikom w-full',
            !isDesktop && 'fixed bottom-0 '
          )}
        >
          <Button
            fullWidth={!isDesktop}
            className="float-right"
            size="lg"
            onClick={() => {
              trackButtonClickStart({
                pemKomPeriod:
                  !configPemKomPeriod.isLoading && configPemKomPeriod.isSuccess
                    ? configPemKomPeriod?.data?.data
                    : null,
              })

              router.push(
                '/pemetaan-kompetensi/uji-kompetensi/SJT?source=panduan'
              )
            }}
          >
            {ujikomPanduanData.data.panduanCta}{' '}
            <Icon fontSize="small" color="inverse" className="ml-1">
              chevron_right
            </Icon>
          </Button>
        </div>
      </PeriodGuard>
    </div>
  )
}

export default Panduan
